export const checkEmpty = value => value && value.trim() !== '';
export const checkGtZero = value => value && value > 0;
export const checkNotEquals = (input, checkWith) => input && input !== checkWith;